module.exports = __webpack_public_path__ + "media/images/icons/chevron-down-90d93e050190dcac0120432c3b6eede6.svg";